import { render, staticRenderFns } from "./ModelEvents.vue?vue&type=template&id=2e58e20a&scoped=true&"
import script from "./ModelEvents.vue?vue&type=script&lang=js&"
export * from "./ModelEvents.vue?vue&type=script&lang=js&"
import style0 from "./ModelEvents.vue?vue&type=style&index=0&id=2e58e20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e58e20a",
  null
  
)

export default component.exports